import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  HBStartDetails: {},
  HBSResultDetails: {},
  dynoStartDetails: {},
  dynoResult: {},
  dynoStopDetails: {},
  HBTestRunningStatus: false,
  dynoTestRunningStatus: false,
  selectedTab: "heartBeat",
  HBHistoryData: [],
  dynoHistoryData: [],
  totalHBElements: 0,
  totalDynoElements: 0,
  HBPaginationDetails: {
    current: 1,
    pageSize: 3,
  },
  dynoPaginationDetails: {
    current: 1,
    pageSize: 3,
  },
  HBPageMini: 1,
  selectedHBTestId: "",
};

const eolTestsSlice = createSlice({
  name: "eolTests",
  initialState,
  reducers: {
    reset: () => initialState,
    setHBPageMini: (state, action) => {
      return {
        ...state,
        HBPageMini: action.payload,
      };
    },
    setSelectedHBTestId: (state, action) => {
      return {
        ...state,
        selectedHBTestId: action.payload,
      };
    },
    setHBStartDetails: (state, action) => {
      return {
        ...state,
        HBStartDetails: action.payload,
      };
    },
    setHBResultDetails: (state, action) => {
      return {
        ...state,
        HBResultDetails: action.payload,
      };
    },
    setDynoStartDetails: (state, action) => {
      return {
        ...state,
        dynoStartDetails: action.payload,
      };
    },
    setDynoResult: (state, action) => {
      return {
        ...state,
        dynoResult: action.payload,
      };
    },
    setDynoStopDetails: (state, action) => {
      return {
        ...state,
        dynoStopDetails: action.payload,
      };
    },
    setHBTestRunningStatus: (state, action) => {
      return {
        ...state,
        HBTestRunningStatus: action.payload,
      };
    },
    setDynoTestRunningStatus: (state, action) => {
      return {
        ...state,
        dynoTestRunningStatus: action.payload,
      };
    },
    setSelectedTab: (state, action) => {
      return {
        ...state,
        selectedTab: action.payload,
      };
    },
    setHBHistoryData: (state, action) => {
      return {
        ...state,
        HBHistoryData: action.payload.list,
        totalHBElements: action.payload.total,
      };
    },
    setDynoHistoryData: (state, action) => {
      return {
        ...state,
        dynoHistoryData: action.payload.list,
        totalDynoElements: action.payload.total,
      };
    },
    setHBPaginationDetails: (state, action) => {
      return {
        ...state,
        HBPaginationDetails: {
          ...state.HBPaginationDetails,
          ...action.payload,
        },
      };
    },
    setDynoPaginationDetails: (state, action) => {
      return {
        ...state,
        dynoPaginationDetails: {
          ...state.dynoPaginationDetails,
          ...action.payload,
        },
      };
    },
  },
});

export const {
  setHBStartDetails,
  setHBResultDetails,
  setDynoStartDetails,
  setDynoResult,
  setDynoStopDetails,
  setHBTestRunningStatus,
  setDynoTestRunningStatus,
  reset,
  setSelectedTab,
  setHBHistoryData,
  setDynoHistoryData,
  setHBPaginationDetails,
  setDynoPaginationDetails,
  setHBPageMini,
  setSelectedHBTestId,
} = eolTestsSlice.actions;
export default eolTestsSlice.reducer;
